






































































































import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import { AgentOfficeCriteria } from '@/components/criteria/agent-office-criteria';
import {
    IDictionary,
    IFormControl,
    IListItem,
    ISite,
    GroupBy,
    AgentQuery,
    DateRangeMapper
} from '../../../entities';
import * as types from '../../../store/types';
import sitesApi from '@/api/sites.api';
import typesApi from '@/api/site-types.api';
import avpPeriodsApi from '@/api/avp-periods.api';
// import { ISite } from '@/entities/sites/site.interface';
// import * as types from '@/store/types';
import { mapGetters } from 'vuex';

import {
    createAvpPeriodListItems,
    parsePeriodListItem,
    parseDate,
    formatDate
} from '../../../utils';
import { ISitesStatsCriteria } from './sites-stats-criteria.interface';
import {
    avpPeriodToListView,
    IAvpPeriod
} from '@/entities/avp-periods/avp-period.interface';

const initTypes: IListItem[] = [{ heading: 'All', value: null }];

@Component({
    computed: mapGetters({
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS
    })
})
export default class SitesAvpStatsPayoutCriteria extends AgentOfficeCriteria {
    @Prop() public newFilter: any;
    @Prop({ default: GroupBy.Company }) public initialGroupBy: GroupBy;

    public formState: IDictionary<IFormControl> = {
        siteId: {
            key: 'siteId',
            label: 'Site',
            value: null
        },
        avp: {
            key: 'avp',
            label: 'Avp',
            value: null
        },
        groupBy: {
            key: 'groupBy',
            label: 'View By',
            value: this.initialGroupBy
        },
        typeId: {
            key: 'typeId',
            label: 'Type',
            value: null
        },
        companyId: {
            key: 'companyId',
            label: 'Office',
            value: null
        },
        agentId: {
            key: 'agentId',
            label: 'Agent',
            value: null
        },
        dateRange: {
            key: 'dateRange',
            label: 'Date',
            value: parsePeriodListItem(createAvpPeriodListItems()[0].value),
            mapper: DateRangeMapper
        }
    };

    public adminPermissions: boolean;

    public sites: IListItem[] = [];
    public avpPeriods: IAvpPeriod[] = [];
    public avpPeriodsOptions: IListItem[] = [];
    public types: IListItem[] = [...initTypes];
    public sitesInProgress: boolean = false;
    public typesInProgress: boolean = false;
    public dateRangeHints: IListItem[] = [
        ...createAvpPeriodListItems()
    ];

    public groupByValues: IListItem[] = [
        {
            heading: 'Date',
            value: GroupBy.Date
        },
        {
            heading: 'Office',
            value: GroupBy.Company
        },
        {
            heading: 'Agent',
            value: GroupBy.Agent
        },
        {
            heading: 'Detail',
            value: GroupBy.Detail
        }
    ];

    get typesDisabled() {
        return this.typesInProgress;
    }

    get avpVisible() {
        return this.adminPermissions;
            // (this.formState.groupBy.value === GroupBy.Agent ||
            //     this.formState.groupBy.value === GroupBy.Detail)
    }

    get isValid() {
        return true;
    }

    get criteriaStr(): string {
        return this.calculateCriteriaStr();
    }

    public async created() {
        super.created();

        this.agentQuery = AgentQuery.OnlyAvailablePlusSuspended;
        this.sitesInProgress = true;
        try {
            const [siteItems, avpPeriods] = await Promise.all([
                sitesApi.list(),
                avpPeriodsApi.list()
            ]);

            const mappedSites: IListItem[] = siteItems.map((x) => {
                return { value: x.id, heading: x.sitename };
            });
            this.sites = [
                { heading: 'All sites', value: null },
                ...mappedSites
            ];
            this.avpPeriods = avpPeriods;
            this.avpPeriodsOptions = [
                {
                    heading: 'All sales (A.V.P. Agent Volume Pay)',
                    value: null
                },
                ...avpPeriods.map(avpPeriodToListView) as IListItem[]
            ];
        } finally {
            this.sitesInProgress = false;
        }

        this.doSearch();
    }

    public defaultFormValues(): IDictionary<any> {
        return {
            siteId: null,
            groupBy: this.initialGroupBy,
            typeId: null,
            companyId: null,
            agentId: null,
            avp: null,
            dateRange: parsePeriodListItem(createAvpPeriodListItems()[0].value)
        };
    }

    public getQueryObject(formState: IDictionary<IFormControl>) {
        return {
            groupBy: formState.groupBy.value,
            siteId: formState.siteId.value,
            typeId: formState.typeId.value,
            companyId: formState.companyId.value,
            avp: formState.avp.value,
            agentId: formState.agentId.value,
            start: formatDate(formState.dateRange.value.start),
            end: formatDate(formState.dateRange.value.end)
        };
    }

    public resetFilter(newFilter: any): void {
        Object.keys(newFilter).forEach((key) => {
            this.formState[key].value = newFilter[key];
        });

        this.submit();
    }

    public siteChange() {
        //  this._reloadTypes(this.formState.siteId.value);
    }

    // public datePeriodChange() {
    //     const period = parsePeriodListItem(this.dateRangeHint.value);
    //     this.formState.dateRange.value = {
    //         from: period.start,
    //         to: period.end
    //     };
    // }

    @Emit()
    public search(body) {
        this.criteriastrchanged(this.calculateCriteriaStr());
    }

    @Emit()
    public criteriastrchanged(body) {
        // empty
    }

    private calculateCriteriaStr() {
        const from = formatDate(this.formState.dateRange.value.start);
        const to = formatDate(this.formState.dateRange.value.end);
        const siteName = this.getOptionHeading(
            this.sites,
            this.formState.siteId.value
        );
        const typeName = this.getOptionHeading(
            this.types,
            this.formState.typeId.value
        );
        const officeName = this.getOptionHeading(
            this.companies,
            this.formState.companyId.value
        );
        const agentName = this.getOptionHeading(
            this.agents,
            this.formState.agentId.value
        );
        // const avp = this.getOptionHeading(
        //     this.avpPeriods,
        //     this.formState.avp.value
        // );
        if (!siteName || !typeName || !officeName || !agentName) {
            return null;
        }
        return `From ${from} To ${to}  [${siteName}, Type:${typeName}, Office:${officeName}, Agent:${agentName}]`;
    }

    private getOptionHeading(options: IListItem[], val: string) {
        // !do not use triple-equals here
        // tslint:disable-next-line:triple-equals
        const item = options.find((x) => x.value == val);
        if (!item) {
            return null;
        }
        return item.heading;
    }

    private async _reloadTypes(siteId: number = null) {
        if (!siteId) {
            this.types = [...initTypes];
            this.formState.typeId.value = null;
            return;
        }
        this.typesInProgress = true;
        try {
            const items = await typesApi.list(siteId, {
                sortField: 'typename',
                sortAsc: true
            });
            const mapped: IListItem[] = items.map((x) => {
                return { heading: x.typename, value: x.id };
            });
            this.types = [{ heading: 'All', value: null }, ...mapped];
            // drop current type
            if (
                !mapped.find(
                    (x) => x.value === Number(this.formState.typeId.value)
                )
            ) {
                this.formState.typeId.value = null;
            }
        } finally {
            this.typesInProgress = false;
        }
    }

    @Watch('$route')
    private onRouteChanged(val: string, oldVal: string) {
        this.doSearch();
    }

    @Watch('criteriaStr')
    private onCriteriaStrChanged(val: any, oldVal: any) {
        if (val !== oldVal) {
            this.criteriastrchanged(val);
        }
    }

    @Watch('formState.siteId.value')
    private onSiteIdChanged(val: string, oldVal: string) {
        this._reloadTypes(this.formState.siteId.value);
    }

    @Watch('formState.companyId.value')
    private onCompanyIdChanged(val: string, oldVal: string) {
        this._reloadAgents(this.formState.companyId.value);
    }

    @Watch('newFilter')
    private onNewFilterChanged(val: any, oldVal: any) {
        this.resetFilter(val);
    }
}
